import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc2000',
    ecrans: ['00-2'],
    params: ['?efface_criteres']
});

